import { URLs } from '../constants/apiEndpoints';
import { PrivateAxiosInstance } from './createAxiosInstance';

// submit signal
export const submitSignal = async (formData) => {
  await PrivateAxiosInstance.post(URLs.MARKET_SIGNAL, formData);
};

// get all signal
export const getAllSignal = async (limit) => {
  const queryParams = new URLSearchParams({
    page: '1',
    limit: limit.meta ? String(limit) : '4',
    sortOrder: 'desc',
    sortBy: 'CreatedAt',
  }).toString();
  const res = await PrivateAxiosInstance.get(
    `${URLs.MARKET_SIGNAL}?${queryParams}`
  );
  return res?.data?.signals;
};

// get all signal
export const getByIdSignal = async (id) => {
  const res = await PrivateAxiosInstance.get(`${URLs.MARKET_SIGNAL}/${id}`);
  return res?.data?.signal;
};

// edit signal
export const editSignal = async ({ formData, id }) => {
  await PrivateAxiosInstance.put(`${URLs.MARKET_SIGNAL}/${id}`, formData);
};

// get all signal
export const deleteSignal = async (id) => {
  await PrivateAxiosInstance.delete(`${URLs.MARKET_SIGNAL}/${id}`);
};
